import scriptjs from 'scriptjs';
import Forms from './Forms';
import Layout from './Layout';
import ProductDetails from './ProductDetails';
import RichText from './RichText';
import jQuery from 'jquery';
export default class Product {
    constructor(section, options = {}) {
        var _a, _b, _c;
        this.section = section;
        this.$el = jQuery(this.section.el);
        this.context = section.data.context;
        this.settings = section.data.settings;
        const variants = (_a = section.data.variants) !== null && _a !== void 0 ? _a : section.data.product.variants;
        section.data = Object.assign(Object.assign({}, section.data), { product: Object.assign(Object.assign({}, section.data.product), { title: (_b = section.data.title) !== null && _b !== void 0 ? _b : section.data.product.title, variants }) });
        const title = (_c = section.data.title) !== null && _c !== void 0 ? _c : section.data.product.title;
        jQuery('.product-title').html(title);
        this.product = section.data.product;
        this.richText = null;
        this.readmoreText = null;
        this.reviewForm = null; // History
        this.isThemeEditor = window.Shopify && window.Shopify.designMode;
        this.useHistory = 'useHistory' in options ? options.useHistory : !!(!this.isThemeEditor && history.replaceState);
        var gallery = this.$el.find('[data-product-gallery]')[0];
        if (gallery === undefined) {
            gallery = jQuery('[data-product-gallery][data-product-id=' + this.product.id + ']')[0];
        }
        const productWrapper = this.$el.find('[data-product-wrapper]'); // Product details
        this.$details = this.$el.find('[data-product-details]'); // Product description
        this.$description = this.$el.find('[data-product-description]');
        this.$readmore = this.$el.find('[data-product-readmore]'); // Product form containers
        this.$formRegular = this.$el.find('[data-product-form-regular]');
        this.$formAlt = this.$el.find('[data-product-form-alt]'); // Product form area
        this.$formArea = this.$el.find('[data-product-form-area]'); // Move product form and information on breakpoint change
        this.layoutHandler = this.onBreakpointChange.bind(this);
        Layout.onBreakpointChange(this.layoutHandler); // Product reviews
        this.$productReviews = this.$el.find('[data-product-reviews]');
        if (productWrapper.hasClass('layout--three-col')) {
            this._moveForm();
        }
        if (this.$description.length) {
            this.richText = new RichText(this.$description);
        }
        if (this.$readmore.length) {
            this.readmoreText = new RichText(this.$readmore);
        }
        if (this.$productReviews.length) {
            this.reviewForm = new Forms(this.$productReviews, '.spr-form-input');
        } // Instantiate ProductDetails after Shopify API is loaded
        scriptjs(jQuery('[data-scripts]').data('shopify-api-url'), () => {
            this.productDetails = new ProductDetails({
                $formArea: this.$formArea,
                $details: this.$details,
                gallery,
                context: this.context,
                settings: this.settings,
                product: this.product,
                useHistory: this.useHistory,
                sectionId: section.id,
                productEl: this.$el[0],
            });
        });
    }
    onSectionUnload() {
        Layout.offBreakpointChange(this.layoutHandler);
        if (this.productDetails) {
            this.productDetails.unload();
        }
        if (this.richText) {
            this.richText.unload();
        }
        if (this.readmoreText) {
            this.readmoreText.unload();
        }
        if (this.reviewForm) {
            this.reviewForm.unload();
        }
    }
    onBreakpointChange() {
        if (this.$formAlt.length) {
            this._moveForm();
        }
    }
    /**
     * Move product form if is a three column layout
     * @private
     */
    _moveForm() {
        if (Layout.isGreaterThanBreakpoint('M')) {
            if (!jQuery.contains(this.$formAlt[0], this.$formArea[0])) {
                const $form = this.$formArea.detach();
                this.$formAlt.append($form);
            }
        }
        else if (!jQuery.contains(this.$formRegular[0], this.$formArea[0])) {
            const $form = this.$formArea.detach();
            this.$formRegular.append($form);
        }
    }
}
